var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"primary"},[_c('site-header'),_c('main-home'),_c('services-home'),_c('differentials-home'),_c('partners-home'),_c('site-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }